import classNames from 'classnames'
import './FallbackImage.scss'
import FALLBACK_IMAGE from '@assets/FALLBACK_IMAGE.png'

interface FallbackImageProps {
  className?: string
}

export const FallbackImage = ({ className }: FallbackImageProps) => {
  return (
    <div className={classNames('fallback-image-wrapper', className)}>
      <img src={FALLBACK_IMAGE} alt="fallback-image" />
    </div>
  )
}

export default FallbackImage
